<template>
  <div class="lesson_body">
    <div class="lesson_text" v-html="currentStage.text_material ? currentStage.text_material : ''"></div>

    <div class="lesson_images" v-if="currentStage.file_materials && currentStage.file_materials.length">
      <ul>
        <li v-for="(file, i) in currentStage.file_materials" :key="file.filename + i">
          <img v-if="file.type == 1" :src="fileLink(file)" />

          <CourseLessonPdf v-if="file.type == 2" :file="file" :link="fileLink(file)" />

          <CourseLessonVideo v-if="file.type == 3" :file="file" :link="fileLink(file)" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CourseLessonPdf from '@/components/user/my-courses/CourseLessonPdf'
import CourseLessonVideo from '@/components/user/my-courses/CourseLessonVideo'
import { config } from '@/config'

export default {
  components: {
    CourseLessonPdf,
    CourseLessonVideo
  },
  props: {
    currentStage: {
      default: () => {},
      type: Object
    },
    courseId: {
      default: () => null,
      type: Number
    }
  },
  methods: {
    fileLink(file) {
      return `${config.baseUrl}/storage/materials/${this.courseId}/${file.stage_id}/${file.filename}`
    }
  }
}
</script>
